import AstraVGSFormModal from './AstraVGSFormModal';

export default AstraVGSFormModal;
